const ROUTES_TRAINING = {
    BASE: {
        name: 'training-programs'
    }
}

export { ROUTES_TRAINING }
